import { MenuItem } from '@domain/types';
// import { Icon } from 'cve-ui';

export const menuItems: MenuItem[] = [
    {
        name: 'menu.campaigns',
        navigateType: 'internal',
        url: 'campaigns',
        icon: 'campaigns-icon',
        active: true,
        hover: false,
    },
    {
        name: 'menu.offers',
        navigateType: 'internal',
        url: 'offers',
        icon: 'offers-icon',
        active: false,
        hover: false,
    },
    {
        name: 'menu.segments',
        navigateType: 'internal',
        url: 'segments',
        icon: 'segments-icon',
        active: false,
        hover: false,
    },
    {
        name: 'menu.impersonation',
        navigateType: 'internal',
        url: 'impersonation',
        icon: 'impersonation-icon',
        active: false,
        hover: false,
    },
    // {
    //     name: 'menu.vehicles',
    //     navigateType: 'internal',
    //     url: 'vehicles',
    //     icon: Icon.vehicle,
    //     active: false,
    //     hover: false,
    //     track: 'click_menu_vehicles',
    // },
    // {
    //     name: 'menu.wallet',
    //     navigateType: 'internal',
    //     url: 'wallet',
    //     icon: Icon.wallet,
    //     active: false,
    //     hover: false,
    //     track: 'click_menu_wallet',
    // },
    // {
    //     name: 'menu.address',
    //     navigateType: 'internal',
    //     url: 'address-book',
    //     icon: Icon.location,
    //     active: false,
    //     hover: false,
    //     track: 'click_menu_address_list',
    // },
    // {
    //     name: 'menu.help_center',
    //     navigateType: 'newTab',
    //     url: '',
    //     icon: Icon.help,
    //     active: false,
    //     hover: false,
    //     track: 'click_menu_help_center',
    // },
    // {
    //     name: 'menu.legal',
    //     navigateType: 'internal',
    //     url: 'legal',
    //     icon: Icon.legalDocuments,
    //     active: false,
    //     hover: false,
    //     track: 'click_menu_legal',
    // },
    // {
    //     name: 'Log out',
    //     navigateType: 'logout',
    //     icon: 'log-out',
    //     active: false,
    //     hover: false,
    //     url: 'logout',
    //     track: 'click_menu_sign_out',
    // },
];
